<template>
	<Dialog
		ref="dialog"
		:title="isNew ? $t('text.addTicketCategory') : $t('text.editTicketCategory')"
		:confirmLabel="$t('text.saveChanges')"
		:cancelLabel="$t('text.cancel')"
		:confirm-handler="onConfirm"
		:cancel-handler="onCancel"
		:showClose="true"
		:loading="loading"
		:isValid="formValid"
		width="1200px"
	>
		<template #content>
			<TicketCategoryForm
				ref="form"
				v-model="ticketCategory"
				v-model:loading="loading"
				v-model:valid="formValid"
				:serviceProviderId="serviceProviderId"
				showAllLocales
			/>
		</template>
	</Dialog>
</template>

<script>
import Dialog from '@/components/common/Dialog.vue'
import TicketCategoryForm from './TicketCategoryForm.vue'
import Common from '@/mixins/Common.vue'
import Loading from '@/mixins/Loading.vue';

export default {
	name: 'TicketCategoryDialog',
	mixins: [Common, Loading],
	components: { Dialog, TicketCategoryForm },
	props: {
		serviceProviderId: { type: String, default: null },
	},
	emits: ['confirm', 'cancel'],
	data() {
		return {
			loading: false,
			ticketCategory: null,
			ticketCategoryId: null,
			formValid: false,
		}
	},
	computed: {
		isNew() {
			return !this.ticketCategoryId
		},
	},
	methods: {
		async show(ticketCategoryId = null) {
			this.ticketCategoryId = ticketCategoryId
			this.initTicketCategory()
			this.$refs.dialog.show = true
			// Wait for next tick to ensure form ref is available, then load if editing
			if (this.ticketCategoryId) {
				await this.$nextTick()
				await this.$refs.form?.loadTicketCategory(this.ticketCategoryId)
			}
		},
		hide() {
			this.$refs.dialog.show = false
		},
		initTicketCategory() {
			this.ticketCategory = {
				sys: { id: this.ticketCategoryId || '' },
				fields: {
					title: { de: '', en: '', fr: '', it: '', nl: '' },
					ageGroupEnabled: { de: false },
					minAge: { de: null },
					maxAge: { de: null },
					freeTourGuide: { de: false },
					flatRate: { de: false },
				}
			}
		},
		async onConfirm() {
			// Return false to prevent Dialog from closing automatically
			// We handle the close manually after async save completes
			await this.loadingOverlay(async () => {
				const result = await this.$refs.form.save()
				if (result) {
					this.$emit('confirm', result)
					this.hide()
				}
			})
			return false
		},
		onCancel() {
			this.$emit('cancel')
		},
	},
}
</script>
